import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import { Gynecology2Sidebar } from "../Layouts/Gynecology2Sidebar";
import axios from "axios";
import $ from "jquery";

export class MedicalDisorders2 extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      Date: "",
      Type: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    //this.PrintWindow = this.PrintWindow.bind(this);
  }

  componentDidMount() {}

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };
    event.preventDefault();
    console.log(localStorage.getItem("accessToken"));
    console.log(this.state);
    axios
      .post(
        this.api_url+"gynecology2/medicaldisorders/main",
        this.state,
        { headers: headers }
      )
      .then((response) => {
        console.log(response);

        if (response.data["status"]) {
          $(".alert-success").show();
          setTimeout(function () {
            window.location.href = "/gynecology2/previous/abdominal";
          }, 500);
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };
  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    const { Date, Type } = this.state;
    return (
      <div>
        <Headers />
        <Gynecology2Sidebar />

        <main className="content-container ">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-12 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    Medical Disorders
                  </p>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Date
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Date}
                      name="Date"
                      type="date"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Type
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Type}
                      name="Type"
                      type="text"
                      required
                    />
                  </div>
                </div>
              </div>

              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Medical Disorders Saved Successfully.
              </div>

              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default MedicalDisorders2;
